/* eslint-disable no-nested-ternary */
import { Button } from 'antd';
import Spinner from 'components/Spinner';
import React from 'react';
import styled from 'styled-components';
import { hexToRgb } from 'utils';

import { ButtonWithSpinnerType } from './types';

const ButtonStyled = styled(Button)<{
  $color?: string;
  $colorOnHover?: string;
  $bgColor?: string;
  $bgColorOnHover?: string;
  $borderColor?: string;
  $borderColorOnHover?: string;
  $border?: string;
}>`
  ${({ $border }) => ($border ? `border: ${$border} !important; ${$border === 'none' ? 'box-shadow: none' : ''}` : '')};
  ${({ $color }) => ($color ? `color: ${$color} !important` : '')};
  ${({ $bgColor }) => ($bgColor ? `background-color: ${$bgColor} !important` : '')};
  ${({ $borderColor }) => ($borderColor ? `border-color: ${$borderColor} !important` : '')};

  &:hover {
    ${({ $colorOnHover }) => ($colorOnHover ? `color: ${$colorOnHover} !important` : '')};
    ${({ $bgColorOnHover }) => ($bgColorOnHover ? `background-color: ${$bgColorOnHover} !important` : '')};
    ${({ $borderColorOnHover }) => ($borderColorOnHover ? `border-color: ${$borderColorOnHover} !important` : '')};
  }
  &:active {
    ${({ $border }) =>
      $border ? `border: ${$border} !important; ${$border === 'none' ? 'box-shadow: none' : ''}` : ''};
    ${({ $color }) => ($color ? `color: ${$color} !important` : '')};
    ${({ $bgColor }) => ($bgColor ? `background-color: ${$bgColor} !important` : '')};
    ${({ $borderColor }) => ($borderColor ? `border-color: ${$borderColor} !important` : '')};
  }

  display: inline-flex;
  align-items: center;
  justify-content: center;
  & > span {
    display: inline;
  }
  transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), border 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
    background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
`;

const ButtonWithSpinner: React.FC<ButtonWithSpinnerType> = ({
  buttonType,
  htmlType,
  width = '90px',
  height,
  isLoading,
  className,
  children,
  onClick,
  danger,
  spinnerColor,
  color,
  colorOnHover,
  bgColor,
  bgColorOnHover,
  border,
  borderColor,
  borderColorOnHover,
  style,
  rounded,
  disabled,
}) => {
  let bgColorOnHoverDefault;
  if (!buttonType || buttonType === 'primary') {
    bgColorOnHoverDefault = onClick ? hexToRgb('#038fde', 0.7) : '#038fde';
  }
  if (bgColor) bgColorOnHoverDefault = onClick ? hexToRgb(bgColor, 0.7) : bgColor;
  const colorOnHoverDefault = color ? (onClick ? hexToRgb(color, 0.7) : color) : undefined;

  return (
    <ButtonStyled
      $color={color}
      $colorOnHover={colorOnHover || colorOnHoverDefault}
      $bgColor={bgColor || (buttonType === 'text' ? 'transparent' : undefined)}
      $bgColorOnHover={bgColorOnHover || bgColorOnHoverDefault}
      $borderColor={borderColor || (buttonType === 'text' ? 'transparent' : undefined)}
      $borderColorOnHover={borderColorOnHover}
      $border={border}
      style={{
        width,
        height,
        borderRadius: rounded === false ? 0 : undefined,
        cursor: onClick || htmlType === 'submit' ? 'pointer' : 'auto',
        ...style,
      }}
      type={buttonType || 'primary'}
      danger={danger}
      className={`gx-mb-0 ${className}`}
      htmlType={htmlType || 'button'}
      disabled={isLoading || !!disabled}
      onClick={onClick}>
      {isLoading ? <Spinner color={spinnerColor} /> : children}
    </ButtonStyled>
  );
};

export default React.memo(ButtonWithSpinner);
